import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  LoginWrapper, LoginCard, LoginError, FormGroup, SaveBtn,
} from './styles/AdminStyles';

const Login = () => {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (user) return <Navigate to="/admin" />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(username, password);
      navigate('/admin');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <LoginWrapper>
      <LoginCard>
        <span className="eyebrow">Ehcerex</span>
        <h2>CMS Console</h2>
        <p>Sign in to manage your website</p>
        {error && <LoginError>{error}</LoginError>}
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <label>Username</label>
            <input
              value={username}
              onChange={e => setUsername(e.target.value)}
              required
              autoFocus
            />
          </FormGroup>
          <FormGroup>
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </FormGroup>
          <SaveBtn type="submit" disabled={submitting} style={{ width: '100%', justifyContent: 'center', marginTop: '0.5rem' }}>
            {submitting ? 'Signing in...' : 'Sign In'}
          </SaveBtn>
        </form>
      </LoginCard>
    </LoginWrapper>
  );
};

export default Login;
